import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.games.games,
    props.user.logins,
    props.app.snowfall,
    (games, logins, snowfall) => {
        const list = [];

        for(const game of games) {
            const login = logins.filter(l => l.game === game.slug)[0] || false;

            list.push({
                ...game,
                login
            });
        }

        return {
            games: list.sort((a, b) => {
                if (a.new !== b.new) {
                    return a.new ? -1 : 1;
                }

                const a_balance = a.login?.balance ?? 0;
                const b_balance = b.login?.balance ?? 0;

                return b_balance - a_balance;
            }),
            // games: list.sort((a,b) => {
            //     const a_balance = a.login ? a.login.balance : 0,
            //           b_balance = b.login ? b.login.balance : 0;

            //     if(a_balance < b_balance) return 1;
            //     if(a_balance > b_balance) return -1;
            //     return 0;
            // }),
            snowfall
        }
    }
)